module.exports = __webpack_public_path__ + "static/avatar-c8c610c1e51482dc121829824c85ab41.png";